import { jsx as f, Fragment as D, jsxs as T } from "react/jsx-runtime";
import * as me from "react";
import { useContext as I, useMemo as B } from "react";
const he = 6048e5, ct = 864e5, it = 6e4, ye = 36e5, se = Symbol.for("constructDateFrom");
function y(r, t) {
  return typeof r == "function" ? r(t) : r && typeof r == "object" && se in r ? r[se](t) : r instanceof Date ? new r.constructor(t) : new Date(t);
}
function o(r, t) {
  return y(t || r, r);
}
function z(r, t, e) {
  const n = o(r, e == null ? void 0 : e.in);
  return isNaN(t) ? y((e == null ? void 0 : e.in) || r, NaN) : (t && n.setDate(n.getDate() + t), n);
}
function ge(r, t, e) {
  return y((e == null ? void 0 : e.in) || r, +o(r) + t);
}
function dt(r, t, e) {
  return ge(r, t * ye, e);
}
function Me(r, t, e) {
  const n = o(r, e == null ? void 0 : e.in);
  return n.setTime(n.getTime() + t * it), n;
}
function q(r, t, e) {
  const n = o(r, e == null ? void 0 : e.in);
  if (isNaN(t)) return y((e == null ? void 0 : e.in) || r, NaN);
  if (!t)
    return n;
  const a = n.getDate(), s = y((e == null ? void 0 : e.in) || r, n.getTime());
  s.setMonth(n.getMonth() + t + 1, 0);
  const c = s.getDate();
  return a >= c ? s : (n.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    a
  ), n);
}
function ot(r, t, e) {
  return q(r, t * 3, e);
}
function ft(r, t, e) {
  return z(r, t * 7, e);
}
function be(r, t, e) {
  return q(r, t * 12, e);
}
function O(r, ...t) {
  const e = y.bind(
    null,
    r || t.find((n) => typeof n == "object")
  );
  return t.map(e);
}
function ue(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return Math.trunc(e.getMonth() / 3) + 1;
}
function lt(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  ), s = n.getFullYear() - a.getFullYear(), c = ue(n) - ue(a);
  return s * 4 + c;
}
function ce(r) {
  const t = o(r), e = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return e.setUTCFullYear(t.getFullYear()), +r - +e;
}
function F(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return e.setHours(0, 0, 0, 0), e;
}
function De(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  ), s = F(n), c = F(a), i = +s - ce(s), d = +c - ce(c);
  return Math.round((i - d) / ct);
}
function we(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  ), s = ie(n, a), c = Math.abs(
    De(n, a)
  );
  n.setDate(n.getDate() - s * c);
  const i = +(ie(n, a) === -s), d = s * (c - i);
  return d === 0 ? 0 : d;
}
function ie(r, t) {
  const e = r.getFullYear() - t.getFullYear() || r.getMonth() - t.getMonth() || r.getDate() - t.getDate() || r.getHours() - t.getHours() || r.getMinutes() - t.getMinutes() || r.getSeconds() - t.getSeconds() || r.getMilliseconds() - t.getMilliseconds();
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
function Oe(r) {
  return (t) => {
    const n = (r ? Math[r] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
function mt(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  ), s = (+n - +a) / ye;
  return Oe(e == null ? void 0 : e.roundingMethod)(s);
}
function E(r, t) {
  const e = +o(r) - +o(t);
  return e < 0 ? -1 : e > 0 ? 1 : e;
}
function ht(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  ), s = n.getFullYear() - a.getFullYear(), c = n.getMonth() - a.getMonth();
  return s * 12 + c;
}
function J(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return e.setHours(23, 59, 59, 999), e;
}
function Te(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function Se(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return +J(e, t) == +Te(e, t);
}
function yt(r, t, e) {
  const [n, a, s] = O(
    e == null ? void 0 : e.in,
    r,
    r,
    t
  ), c = E(a, s), i = Math.abs(
    ht(a, s)
  );
  if (i < 1) return 0;
  a.getMonth() === 1 && a.getDate() > 27 && a.setDate(30), a.setMonth(a.getMonth() - c * i);
  let d = E(a, s) === -c;
  Se(n) && i === 1 && E(n, s) === 1 && (d = !1);
  const h = c * (i - +d);
  return h === 0 ? 0 : h;
}
function gt(r, t, e) {
  const n = we(r, t, e) / 7;
  return Oe(e == null ? void 0 : e.roundingMethod)(n);
}
function Mt(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  );
  return n.getFullYear() - a.getFullYear();
}
function bt(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  ), s = E(n, a), c = Math.abs(Mt(n, a));
  n.setFullYear(1584), a.setFullYear(1584);
  const i = E(n, a) === -s, d = s * (c - +i);
  return d === 0 ? 0 : d;
}
function Dt(r, t) {
  const [e, n] = O(r, t.start, t.end);
  return { start: e, end: n };
}
function wt(r, t) {
  const { start: e, end: n } = Dt(t == null ? void 0 : t.in, r);
  let a = +e > +n;
  const s = a ? +e : +n, c = a ? n : e;
  c.setHours(0, 0, 0, 0);
  let i = (t == null ? void 0 : t.step) ?? 1;
  if (!i) return [];
  i < 0 && (i = -i, a = !a);
  const d = [];
  for (; +c <= s; )
    d.push(y(e, c)), c.setDate(c.getDate() + i), c.setHours(0, 0, 0, 0);
  return a ? d.reverse() : d;
}
function Ot(r) {
  return J(Date.now(), r);
}
let Tt = {};
function W() {
  return Tt;
}
function St(r, t) {
  var i, d, h, g;
  const e = W(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : d.weekStartsOn) ?? e.weekStartsOn ?? ((g = (h = e.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? 0, a = o(r, t == null ? void 0 : t.in), s = a.getDay(), c = (s < n ? -7 : 0) + 6 - (s - n);
  return a.setDate(a.getDate() + c), a.setHours(23, 59, 59, 999), a;
}
function _t(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function G(r) {
  return y(r, Date.now());
}
function Yt(r) {
  const t = G(r == null ? void 0 : r.in), e = y(r == null ? void 0 : r.in, 0);
  return e.setFullYear(t.getFullYear(), t.getMonth(), t.getDate() - 1), e.setHours(23, 59, 59, 999), e;
}
const Lt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ft = (r, t, e) => {
  let n;
  const a = Lt[r];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "in " + n : n + " ago" : n;
};
function U(r) {
  return (t = {}) => {
    const e = t.width ? String(t.width) : r.defaultWidth;
    return r.formats[e] || r.formats[r.defaultWidth];
  };
}
const kt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Pt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Nt = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, At = {
  date: U({
    formats: kt,
    defaultWidth: "full"
  }),
  time: U({
    formats: Pt,
    defaultWidth: "full"
  }),
  dateTime: U({
    formats: Nt,
    defaultWidth: "full"
  })
}, xt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ht = (r, t, e, n) => xt[r];
function x(r) {
  return (t, e) => {
    const n = e != null && e.context ? String(e.context) : "standalone";
    let a;
    if (n === "formatting" && r.formattingValues) {
      const c = r.defaultFormattingWidth || r.defaultWidth, i = e != null && e.width ? String(e.width) : c;
      a = r.formattingValues[i] || r.formattingValues[c];
    } else {
      const c = r.defaultWidth, i = e != null && e.width ? String(e.width) : r.defaultWidth;
      a = r.values[i] || r.values[c];
    }
    const s = r.argumentCallback ? r.argumentCallback(t) : t;
    return a[s];
  };
}
const Et = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Wt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, vt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Ct = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Rt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, It = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, qt = (r, t) => {
  const e = Number(r), n = e % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return e + "st";
      case 2:
        return e + "nd";
      case 3:
        return e + "rd";
    }
  return e + "th";
}, jt = {
  ordinalNumber: qt,
  era: x({
    values: Et,
    defaultWidth: "wide"
  }),
  quarter: x({
    values: Wt,
    defaultWidth: "wide",
    argumentCallback: (r) => r - 1
  }),
  month: x({
    values: vt,
    defaultWidth: "wide"
  }),
  day: x({
    values: Ct,
    defaultWidth: "wide"
  }),
  dayPeriod: x({
    values: Rt,
    defaultWidth: "wide",
    formattingValues: It,
    defaultFormattingWidth: "wide"
  })
};
function H(r) {
  return (t, e = {}) => {
    const n = e.width, a = n && r.matchPatterns[n] || r.matchPatterns[r.defaultMatchWidth], s = t.match(a);
    if (!s)
      return null;
    const c = s[0], i = n && r.parsePatterns[n] || r.parsePatterns[r.defaultParseWidth], d = Array.isArray(i) ? Qt(i, (w) => w.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      Xt(i, (w) => w.test(c))
    );
    let h;
    h = r.valueCallback ? r.valueCallback(d) : d, h = e.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      e.valueCallback(h)
    ) : h;
    const g = t.slice(c.length);
    return { value: h, rest: g };
  };
}
function Xt(r, t) {
  for (const e in r)
    if (Object.prototype.hasOwnProperty.call(r, e) && t(r[e]))
      return e;
}
function Qt(r, t) {
  for (let e = 0; e < r.length; e++)
    if (t(r[e]))
      return e;
}
function Ut(r) {
  return (t, e = {}) => {
    const n = t.match(r.matchPattern);
    if (!n) return null;
    const a = n[0], s = t.match(r.parsePattern);
    if (!s) return null;
    let c = r.valueCallback ? r.valueCallback(s[0]) : s[0];
    c = e.valueCallback ? e.valueCallback(c) : c;
    const i = t.slice(a.length);
    return { value: c, rest: i };
  };
}
const Vt = /^(\d+)(th|st|nd|rd)?/i, Bt = /\d+/i, Gt = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, $t = {
  any: [/^b/i, /^(a|c)/i]
}, zt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Jt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Kt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, pt = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, er = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, tr = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, rr = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, nr = {
  ordinalNumber: Ut({
    matchPattern: Vt,
    parsePattern: Bt,
    valueCallback: (r) => parseInt(r, 10)
  }),
  era: H({
    matchPatterns: Gt,
    defaultMatchWidth: "wide",
    parsePatterns: $t,
    defaultParseWidth: "any"
  }),
  quarter: H({
    matchPatterns: zt,
    defaultMatchWidth: "wide",
    parsePatterns: Jt,
    defaultParseWidth: "any",
    valueCallback: (r) => r + 1
  }),
  month: H({
    matchPatterns: Zt,
    defaultMatchWidth: "wide",
    parsePatterns: Kt,
    defaultParseWidth: "any"
  }),
  day: H({
    matchPatterns: pt,
    defaultMatchWidth: "wide",
    parsePatterns: er,
    defaultParseWidth: "any"
  }),
  dayPeriod: H({
    matchPatterns: tr,
    defaultMatchWidth: "any",
    parsePatterns: rr,
    defaultParseWidth: "any"
  })
}, ar = {
  code: "en-US",
  formatDistance: Ft,
  formatLong: At,
  formatRelative: Ht,
  localize: jt,
  match: nr,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function _e(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return e.setFullYear(e.getFullYear(), 0, 1), e.setHours(0, 0, 0, 0), e;
}
function sr(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return De(e, _e(e)) + 1;
}
function k(r, t) {
  var i, d, h, g;
  const e = W(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : d.weekStartsOn) ?? e.weekStartsOn ?? ((g = (h = e.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? 0, a = o(r, t == null ? void 0 : t.in), s = a.getDay(), c = (s < n ? 7 : 0) + s - n;
  return a.setDate(a.getDate() - c), a.setHours(0, 0, 0, 0), a;
}
function v(r, t) {
  return k(r, { ...t, weekStartsOn: 1 });
}
function Ye(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = e.getFullYear(), a = y(e, 0);
  a.setFullYear(n + 1, 0, 4), a.setHours(0, 0, 0, 0);
  const s = v(a), c = y(e, 0);
  c.setFullYear(n, 0, 4), c.setHours(0, 0, 0, 0);
  const i = v(c);
  return e.getTime() >= s.getTime() ? n + 1 : e.getTime() >= i.getTime() ? n : n - 1;
}
function ur(r, t) {
  const e = Ye(r, t), n = y(r, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), v(n);
}
function cr(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = +v(e) - +ur(e);
  return Math.round(n / he) + 1;
}
function Le(r, t) {
  var g, w, N, A;
  const e = o(r, t == null ? void 0 : t.in), n = e.getFullYear(), a = W(), s = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((w = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : w.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((A = (N = a.locale) == null ? void 0 : N.options) == null ? void 0 : A.firstWeekContainsDate) ?? 1, c = y((t == null ? void 0 : t.in) || r, 0);
  c.setFullYear(n + 1, 0, s), c.setHours(0, 0, 0, 0);
  const i = k(c, t), d = y((t == null ? void 0 : t.in) || r, 0);
  d.setFullYear(n, 0, s), d.setHours(0, 0, 0, 0);
  const h = k(d, t);
  return +e >= +i ? n + 1 : +e >= +h ? n : n - 1;
}
function ir(r, t) {
  var i, d, h, g;
  const e = W(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : d.firstWeekContainsDate) ?? e.firstWeekContainsDate ?? ((g = (h = e.locale) == null ? void 0 : h.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, a = Le(r, t), s = y((t == null ? void 0 : t.in) || r, 0);
  return s.setFullYear(a, 0, n), s.setHours(0, 0, 0, 0), k(s, t);
}
function dr(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = +k(e, t) - +ir(e, t);
  return Math.round(n / he) + 1;
}
function m(r, t) {
  const e = r < 0 ? "-" : "", n = Math.abs(r).toString().padStart(t, "0");
  return e + n;
}
const S = {
  // Year
  y(r, t) {
    const e = r.getFullYear(), n = e > 0 ? e : 1 - e;
    return m(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(r, t) {
    const e = r.getMonth();
    return t === "M" ? String(e + 1) : m(e + 1, 2);
  },
  // Day of the month
  d(r, t) {
    return m(r.getDate(), t.length);
  },
  // AM or PM
  a(r, t) {
    const e = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.toUpperCase();
      case "aaa":
        return e;
      case "aaaaa":
        return e[0];
      case "aaaa":
      default:
        return e === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(r, t) {
    return m(r.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(r, t) {
    return m(r.getHours(), t.length);
  },
  // Minute
  m(r, t) {
    return m(r.getMinutes(), t.length);
  },
  // Second
  s(r, t) {
    return m(r.getSeconds(), t.length);
  },
  // Fraction of second
  S(r, t) {
    const e = t.length, n = r.getMilliseconds(), a = Math.trunc(
      n * Math.pow(10, e - 3)
    );
    return m(a, t.length);
  }
}, L = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, de = {
  // Era
  G: function(r, t, e) {
    const n = r.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return e.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return e.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return e.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(r, t, e) {
    if (t === "yo") {
      const n = r.getFullYear(), a = n > 0 ? n : 1 - n;
      return e.ordinalNumber(a, { unit: "year" });
    }
    return S.y(r, t);
  },
  // Local week-numbering year
  Y: function(r, t, e, n) {
    const a = Le(r, n), s = a > 0 ? a : 1 - a;
    if (t === "YY") {
      const c = s % 100;
      return m(c, 2);
    }
    return t === "Yo" ? e.ordinalNumber(s, { unit: "year" }) : m(s, t.length);
  },
  // ISO week-numbering year
  R: function(r, t) {
    const e = Ye(r);
    return m(e, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(r, t) {
    const e = r.getFullYear();
    return m(e, t.length);
  },
  // Quarter
  Q: function(r, t, e) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return m(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return e.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return e.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return e.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return e.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(r, t, e) {
    const n = Math.ceil((r.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return m(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return e.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return e.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return e.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return e.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(r, t, e) {
    const n = r.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return S.M(r, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return e.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return e.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return e.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return e.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(r, t, e) {
    const n = r.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return m(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return e.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return e.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return e.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return e.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(r, t, e, n) {
    const a = dr(r, n);
    return t === "wo" ? e.ordinalNumber(a, { unit: "week" }) : m(a, t.length);
  },
  // ISO week of year
  I: function(r, t, e) {
    const n = cr(r);
    return t === "Io" ? e.ordinalNumber(n, { unit: "week" }) : m(n, t.length);
  },
  // Day of the month
  d: function(r, t, e) {
    return t === "do" ? e.ordinalNumber(r.getDate(), { unit: "date" }) : S.d(r, t);
  },
  // Day of year
  D: function(r, t, e) {
    const n = sr(r);
    return t === "Do" ? e.ordinalNumber(n, { unit: "dayOfYear" }) : m(n, t.length);
  },
  // Day of week
  E: function(r, t, e) {
    const n = r.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return e.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return e.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return e.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return e.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(r, t, e, n) {
    const a = r.getDay(), s = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return m(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return e.ordinalNumber(s, { unit: "day" });
      case "eee":
        return e.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return e.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return e.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return e.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(r, t, e, n) {
    const a = r.getDay(), s = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return m(s, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return e.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return e.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return e.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return e.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return e.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(r, t, e) {
    const n = r.getDay(), a = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return m(a, t.length);
      // 2nd
      case "io":
        return e.ordinalNumber(a, { unit: "day" });
      // Tue
      case "iii":
        return e.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return e.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return e.day(n, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return e.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(r, t, e) {
    const a = r.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return e.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return e.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(r, t, e) {
    const n = r.getHours();
    let a;
    switch (n === 12 ? a = L.noon : n === 0 ? a = L.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return e.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return e.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(r, t, e) {
    const n = r.getHours();
    let a;
    switch (n >= 17 ? a = L.evening : n >= 12 ? a = L.afternoon : n >= 4 ? a = L.morning : a = L.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return e.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return e.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return e.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(r, t, e) {
    if (t === "ho") {
      let n = r.getHours() % 12;
      return n === 0 && (n = 12), e.ordinalNumber(n, { unit: "hour" });
    }
    return S.h(r, t);
  },
  // Hour [0-23]
  H: function(r, t, e) {
    return t === "Ho" ? e.ordinalNumber(r.getHours(), { unit: "hour" }) : S.H(r, t);
  },
  // Hour [0-11]
  K: function(r, t, e) {
    const n = r.getHours() % 12;
    return t === "Ko" ? e.ordinalNumber(n, { unit: "hour" }) : m(n, t.length);
  },
  // Hour [1-24]
  k: function(r, t, e) {
    let n = r.getHours();
    return n === 0 && (n = 24), t === "ko" ? e.ordinalNumber(n, { unit: "hour" }) : m(n, t.length);
  },
  // Minute
  m: function(r, t, e) {
    return t === "mo" ? e.ordinalNumber(r.getMinutes(), { unit: "minute" }) : S.m(r, t);
  },
  // Second
  s: function(r, t, e) {
    return t === "so" ? e.ordinalNumber(r.getSeconds(), { unit: "second" }) : S.s(r, t);
  },
  // Fraction of second
  S: function(r, t) {
    return S.S(r, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(r, t, e) {
    const n = r.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return fe(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Y(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Y(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(r, t, e) {
    const n = r.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return fe(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Y(n);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Y(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(r, t, e) {
    const n = r.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + oe(n, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Y(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(r, t, e) {
    const n = r.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + oe(n, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Y(n, ":");
    }
  },
  // Seconds timestamp
  t: function(r, t, e) {
    const n = Math.trunc(+r / 1e3);
    return m(n, t.length);
  },
  // Milliseconds timestamp
  T: function(r, t, e) {
    return m(+r, t.length);
  }
};
function oe(r, t = "") {
  const e = r > 0 ? "-" : "+", n = Math.abs(r), a = Math.trunc(n / 60), s = n % 60;
  return s === 0 ? e + String(a) : e + String(a) + t + m(s, 2);
}
function fe(r, t) {
  return r % 60 === 0 ? (r > 0 ? "-" : "+") + m(Math.abs(r) / 60, 2) : Y(r, t);
}
function Y(r, t = "") {
  const e = r > 0 ? "-" : "+", n = Math.abs(r), a = m(Math.trunc(n / 60), 2), s = m(n % 60, 2);
  return e + a + t + s;
}
const le = (r, t) => {
  switch (r) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Fe = (r, t) => {
  switch (r) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, or = (r, t) => {
  const e = r.match(/(P+)(p+)?/) || [], n = e[1], a = e[2];
  if (!a)
    return le(r, t);
  let s;
  switch (n) {
    case "P":
      s = t.dateTime({ width: "short" });
      break;
    case "PP":
      s = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = t.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", le(n, t)).replace("{{time}}", Fe(a, t));
}, fr = {
  p: Fe,
  P: or
}, lr = /^D+$/, mr = /^Y+$/, hr = ["D", "DD", "YY", "YYYY"];
function yr(r) {
  return lr.test(r);
}
function gr(r) {
  return mr.test(r);
}
function Mr(r, t, e) {
  const n = br(r, t, e);
  if (console.warn(n), hr.includes(r)) throw new RangeError(n);
}
function br(r, t, e) {
  const n = r[0] === "Y" ? "years" : "days of the month";
  return `Use \`${r.toLowerCase()}\` instead of \`${r}\` (in \`${t}\`) for formatting ${n} to the input \`${e}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function ke(r) {
  return r instanceof Date || typeof r == "object" && Object.prototype.toString.call(r) === "[object Date]";
}
function Pe(r) {
  return !(!ke(r) && typeof r != "number" || isNaN(+o(r)));
}
const Dr = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, wr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Or = /^'([^]*?)'?$/, Tr = /''/g, Sr = /[a-zA-Z]/;
function _r(r, t, e) {
  var g, w, N, A, te, re, ne, ae;
  const n = W(), a = (e == null ? void 0 : e.locale) ?? n.locale ?? ar, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((w = (g = e == null ? void 0 : e.locale) == null ? void 0 : g.options) == null ? void 0 : w.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((A = (N = n.locale) == null ? void 0 : N.options) == null ? void 0 : A.firstWeekContainsDate) ?? 1, c = (e == null ? void 0 : e.weekStartsOn) ?? ((re = (te = e == null ? void 0 : e.locale) == null ? void 0 : te.options) == null ? void 0 : re.weekStartsOn) ?? n.weekStartsOn ?? ((ae = (ne = n.locale) == null ? void 0 : ne.options) == null ? void 0 : ae.weekStartsOn) ?? 0, i = o(r, e == null ? void 0 : e.in);
  if (!Pe(i))
    throw new RangeError("Invalid time value");
  let d = t.match(wr).map((b) => {
    const M = b[0];
    if (M === "p" || M === "P") {
      const Q = fr[M];
      return Q(b, a.formatLong);
    }
    return b;
  }).join("").match(Dr).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const M = b[0];
    if (M === "'")
      return { isToken: !1, value: Yr(b) };
    if (de[M])
      return { isToken: !0, value: b };
    if (M.match(Sr))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + M + "`"
      );
    return { isToken: !1, value: b };
  });
  a.localize.preprocessor && (d = a.localize.preprocessor(i, d));
  const h = {
    firstWeekContainsDate: s,
    weekStartsOn: c,
    locale: a
  };
  return d.map((b) => {
    if (!b.isToken) return b.value;
    const M = b.value;
    (!(e != null && e.useAdditionalWeekYearTokens) && gr(M) || !(e != null && e.useAdditionalDayOfYearTokens) && yr(M)) && Mr(M, t, String(r));
    const Q = de[M[0]];
    return Q(i, M, a.localize, h);
  }).join("");
}
function Yr(r) {
  const t = r.match(Or);
  return t ? t[1].replace(Tr, "'") : r;
}
function Lr(r, t) {
  return o(r, t == null ? void 0 : t.in).getMonth();
}
function Fr(r, t) {
  return +o(r) > +o(t);
}
function kr(r, t) {
  return +o(r) < +o(t);
}
function Pr(r, t) {
  return +o(r) == +o(t);
}
function Nr(r, t) {
  return o(r, t == null ? void 0 : t.in).getDate() === 1;
}
function Ar(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  );
  return +F(n) == +F(a);
}
function xr(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  );
  return n.getFullYear() === a.getFullYear() && n.getMonth() === a.getMonth();
}
function Hr(r, t, e) {
  const [n, a] = O(
    e == null ? void 0 : e.in,
    r,
    t
  );
  return n.getFullYear() === a.getFullYear();
}
function Er(r, t, e) {
  const n = +o(r, e == null ? void 0 : e.in), [a, s] = [
    +o(t.start, e == null ? void 0 : e.in),
    +o(t.end, e == null ? void 0 : e.in)
  ].sort((c, i) => c - i);
  return n >= a && n <= s;
}
function Wr(r, t) {
  let e, n = t == null ? void 0 : t.in;
  return r.forEach((a) => {
    !n && typeof a == "object" && (n = y.bind(null, a));
    const s = o(a, n);
    (!e || e < s || isNaN(+s)) && (e = s);
  }), y(n, e || NaN);
}
function vr(r, t) {
  let e, n = t == null ? void 0 : t.in;
  return r.forEach((a) => {
    !n && typeof a == "object" && (n = y.bind(null, a));
    const s = o(a, n);
    (!e || e > s || isNaN(+s)) && (e = s);
  }), y(n, e || NaN);
}
function Cr(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = e.getFullYear(), a = e.getMonth(), s = y(e, 0);
  return s.setFullYear(n, a + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function Rr(r, t, e) {
  const n = o(r, e == null ? void 0 : e.in), a = n.getFullYear(), s = n.getDate(), c = y((e == null ? void 0 : e.in) || r, 0);
  c.setFullYear(a, t, 15), c.setHours(0, 0, 0, 0);
  const i = Cr(c);
  return n.setMonth(t, Math.min(s, i)), n;
}
function Ir(r, t, e) {
  const n = o(r, e == null ? void 0 : e.in);
  return isNaN(+n) ? y((e == null ? void 0 : e.in) || r, NaN) : (n.setFullYear(t), n);
}
function qr(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return e.setMinutes(0, 0, 0), e;
}
function jr(r, t) {
  const e = o(r, t == null ? void 0 : t.in);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function Xr(r, t) {
  const e = o(r, t == null ? void 0 : t.in), n = e.getMonth(), a = n - n % 3;
  return e.setMonth(a, 1), e.setHours(0, 0, 0, 0), e;
}
function Qr(r) {
  return F(Date.now(), r);
}
function Ur(r) {
  const t = G(r == null ? void 0 : r.in), e = t.getFullYear(), n = t.getMonth(), a = t.getDate(), s = G(r == null ? void 0 : r.in);
  return s.setFullYear(e, n, a - 1), s.setHours(0, 0, 0, 0), s;
}
function Vr(r, t, e) {
  return z(r, -t, e);
}
function Br(r, t, e) {
  return Me(r, -t, e);
}
function Gr(r, t, e) {
  return q(r, -t, e);
}
function $r(r, t, e) {
  return ge(r, t * 1e3, e);
}
function zr(r, t, e) {
  return $r(r, -t, e);
}
function Jr(r, t, e) {
  return be(r, -t, e);
}
const u = {
  isSameMonth: xr,
  isSameYear: Hr,
  getMonth: Lr,
  isDate: ke,
  isFirstDayOfMonth: Nr,
  isLastDayOfMonth: Se,
  isValid: Pe,
  differenceInDays: we,
  differenceInHours: mt,
  differenceInYears: bt,
  differenceInMonths: yt,
  differenceInWeeks: gt,
  differenceInCalendarQuarters: lt,
  addMinutes: Me,
  subMinutes: Br,
  addHours: dt,
  startOfHour: qr,
  startOfToday: Qr,
  endOfToday: Ot,
  startOfYesterday: Ur,
  endOfYesterday: Yt,
  startOfWeek: k,
  endOfWeek: St,
  startOfDay: F,
  endOfDay: J,
  addDays: z,
  subDays: Vr,
  startOfYear: _e,
  endOfYear: _t,
  addYears: be,
  subYears: Jr,
  format: _r,
  startOfMonth: jr,
  endOfMonth: Te,
  subSeconds: zr,
  subMonths: Gr,
  addMonths: q,
  min: vr,
  max: Wr,
  isBefore: kr,
  isAfter: Fr,
  isEqual: Pr,
  isSameDay: Ar,
  eachDayOfInterval: wt,
  isWithinInterval: Er,
  setYear: Ir,
  setMonth: Rr,
  startOfQuarter: Xr,
  addQuarters: ot,
  addWeeks: ft
}, $ = (r, t) => t === "utc" && r.getTimezoneOffset ? r.getTimezoneOffset() : 0;
function Z(r) {
  if (Array.isArray(r))
    return r.map((e) => Z(e));
  if (r instanceof Date)
    return r;
  if (r == null)
    return;
  const t = new Date(r);
  if (u.isValid(t))
    return t;
}
function K(r, t = "utc") {
  if (Array.isArray(r))
    return r.map(
      (a) => K(
        (a instanceof Date, a),
        t
      )
    );
  if (r === void 0)
    return;
  const e = Z(r);
  if (e === void 0)
    return;
  const n = $(e, t);
  return u.subMinutes(e, n);
}
function Ne(r) {
  return Array.isArray(r) ? r.map((t) => Ne(t)) : u.isDate(r) && u.isValid(r) ? r.toISOString() : r;
}
const l = ({
  key: r,
  label: t,
  start: e,
  end: n
}) => {
  const a = K([e, n]);
  return Object.freeze({
    value: Ne(a),
    label: t,
    key: [r]
  });
}, Ae = new Date(2e3, 0, 1, 0, 0, 0), xe = l({
  start: u.startOfToday(),
  end: u.endOfToday(),
  label: "Today",
  key: "TODAY"
}), He = l({
  start: u.startOfYesterday(),
  end: u.endOfYesterday(),
  label: "Yesterday",
  key: "YESTERDAY"
}), Ee = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 2)),
  end: u.endOfDay(u.subDays(/* @__PURE__ */ new Date(), 2)),
  label: "2 days ago",
  key: "DAY_BEFORE_YESTERDAY"
}), We = l({
  start: u.startOfWeek(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }),
  end: u.endOfToday(),
  label: "This week",
  key: "THIS_WEEK"
}), ve = l({
  start: u.startOfMonth(/* @__PURE__ */ new Date()),
  end: u.endOfToday(),
  label: "This month",
  key: "THIS_MONTH"
}), Ce = l({
  start: u.startOfMonth(/* @__PURE__ */ new Date()),
  end: u.endOfYesterday(),
  label: "This month - 1",
  key: "THIS_MONTH_MINUS_1"
}), Re = l({
  start: u.startOfYear(/* @__PURE__ */ new Date()),
  end: u.endOfToday(),
  label: "This year",
  key: "THIS_YEAR"
}), Ie = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 3)),
  end: u.endOfYesterday(),
  label: "Last 3 days",
  key: "LAST_3_DAYS"
}), qe = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 7)),
  end: u.endOfYesterday(),
  label: "Last 7 days",
  key: "LAST_7_DAYS"
}), je = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 10)),
  end: u.endOfYesterday(),
  label: "Last 10 days",
  key: "LAST_10_DAYS"
}), Xe = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 14)),
  end: u.endOfYesterday(),
  label: "Last 14 days",
  key: "LAST_14_DAYS"
}), Qe = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 30)),
  end: u.endOfYesterday(),
  label: "Last 30 days",
  key: "LAST_30_DAYS"
}), Zr = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 30)),
  end: u.endOfToday(),
  label: "Last 30 days + Today",
  key: "LAST_30_DAYS_PLUS_TODAY"
}), Ue = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 90)),
  end: u.endOfYesterday(),
  label: "Last 90 days",
  key: "LAST_90_DAYS"
}), Ve = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 180)),
  end: u.endOfYesterday(),
  label: "Last 180 days",
  key: "LAST_180_DAYS"
}), Be = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 360)),
  end: u.endOfYesterday(),
  label: "Last 360 days",
  key: "LAST_360_DAYS"
}), Kr = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 730)),
  end: u.endOfYesterday(),
  label: "Last 730 days",
  key: "LAST_730_DAYS"
}), pr = l({
  start: u.startOfDay(u.subDays(/* @__PURE__ */ new Date(), 1095)),
  end: u.endOfYesterday(),
  label: "Last 1095 days",
  key: "LAST_1095_DAYS"
}), Ge = l({
  start: u.startOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 1)),
  end: u.endOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 1)),
  label: "Last month",
  key: "LAST_MONTH"
}), $e = l({
  start: u.startOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 2)),
  end: u.endOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 1)),
  label: "Last 2 months",
  key: "LAST_2_MONTHS"
}), ze = l({
  start: u.startOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 3)),
  end: u.endOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 1)),
  label: "Last 3 months",
  key: "LAST_3_MONTHS"
}), en = l({
  start: u.startOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 3)),
  end: u.endOfToday(),
  label: "Last 3 months + current",
  key: "LAST_3_MONTH_PLUS_THIS"
}), Je = l({
  start: u.startOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 11)),
  end: u.endOfYesterday(),
  label: "Last 12 months",
  key: "LAST_12_MONTHS"
}), tn = l({
  start: u.startOfMonth(u.subMonths(/* @__PURE__ */ new Date(), 11)),
  end: u.endOfToday(),
  label: "Last 12 months + Today",
  key: "LAST_12_MONTHS_PLUS_TODAY"
}), Ze = l({
  start: u.startOfYear(u.subYears(/* @__PURE__ */ new Date(), 1)),
  end: u.endOfYear(u.subYears(/* @__PURE__ */ new Date(), 1)),
  label: "Last year",
  key: "LAST_YEAR"
}), Ke = l({
  start: new Date(Ae),
  end: u.endOfToday(),
  label: "Lifetime",
  key: "LIFETIME"
}), pe = l({
  start: new Date(Ae),
  end: u.addYears(u.endOfToday(), 10),
  label: "Lifetime + Future",
  key: "LIFETIME_PLUS_FUTURE"
}), rn = l({
  start: u.startOfMonth(u.addMonths(/* @__PURE__ */ new Date(), 1)),
  end: u.endOfMonth(u.addMonths(/* @__PURE__ */ new Date(), 1)),
  label: "Next month",
  key: "NEXT_MONTH"
}), nn = l({
  start: u.startOfMonth(u.addMonths(/* @__PURE__ */ new Date(), 0)),
  end: u.endOfMonth(u.addMonths(/* @__PURE__ */ new Date(), 1)),
  label: "This + Next months",
  key: "THIS_PLUS_NEXT_MONTH"
}), an = l({
  start: u.startOfWeek(u.addDays(/* @__PURE__ */ new Date(), 7), {
    weekStartsOn: 1
  }),
  end: u.endOfWeek(u.addDays(/* @__PURE__ */ new Date(), 14), { weekStartsOn: 1 }),
  label: "Next 2 weeks",
  key: "NEXT_2_WEEKS"
}), On = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DAY_BEFORE_YESTERDAY: Ee,
  LAST_1095_DAYS: pr,
  LAST_10_DAYS: je,
  LAST_12_MONTHS: Je,
  LAST_12_MONTHS_PLUS_TODAY: tn,
  LAST_14_DAYS: Xe,
  LAST_180_DAYS: Ve,
  LAST_2_MONTHS: $e,
  LAST_30_DAYS: Qe,
  LAST_30_DAYS_PLUS_TODAY: Zr,
  LAST_360_DAYS: Be,
  LAST_3_DAYS: Ie,
  LAST_3_MONTHS: ze,
  LAST_3_MONTH_PLUS_THIS: en,
  LAST_730_DAYS: Kr,
  LAST_7_DAYS: qe,
  LAST_90_DAYS: Ue,
  LAST_MONTH: Ge,
  LAST_YEAR: Ze,
  LIFETIME: Ke,
  LIFETIME_PLUS_FUTURE: pe,
  NEXT_2_WEEKS: an,
  NEXT_MONTH: rn,
  THIS_MONTH: ve,
  THIS_MONTH_MINUS_1: Ce,
  THIS_PLUS_NEXT_MONTH: nn,
  THIS_WEEK: We,
  THIS_YEAR: Re,
  TODAY: xe,
  YESTERDAY: He
}, Symbol.toStringTag, { value: "Module" })), sn = Object.freeze([
  xe,
  He,
  Ee,
  We,
  ve,
  Ce,
  Re,
  Ie,
  qe,
  je,
  Xe,
  Qe,
  Ue,
  Ve,
  Be,
  Ge,
  $e,
  ze,
  Ze,
  Je,
  Ke,
  pe
]), et = me.createContext(void 0), un = ({ children: r, presets: t = sn }) => /* @__PURE__ */ f(et.Provider, { value: { presets: t }, children: r });
function C(r, t = "utc") {
  if (Array.isArray(r))
    return r.map((c) => {
      if (c instanceof Date)
        return C(c, t);
      if (c !== void 0)
        return C(c, t);
    });
  if (r === void 0)
    return;
  const e = Z(r);
  if (e === void 0)
    return;
  const n = $(e, t), a = u.addMinutes(e, n), s = $(a, t);
  return u.addMinutes(e, s);
}
const Tn = ({
  presets: r,
  local: t = !1
}) => {
  const e = I(et), n = B(() => r || (e == null ? void 0 : e.presets) || [], [r, e == null ? void 0 : e.presets]);
  return B(() => n.map(({ value: a, ...s }, c) => ({
    ...s,
    id: c,
    value: t ? C(a) : a
  })), [n, t]);
}, j = me.createContext(
  {
    locale: "il",
    template: "LLL",
    empty: "—"
  }
), cn = ({
  children: r,
  locale: t,
  template: e,
  empty: n
}) => /* @__PURE__ */ f(j.Provider, { value: { locale: t, template: e, empty: n }, children: r }), tt = {
  au: {
    LT: "h:mm aa",
    LTS: "h:mm:ss aa",
    L: "MM/d/yyyy",
    LL: "MMM d, yyyy",
    LLL: "MMM d yyyy, h:mm aa",
    LLLL: "MMM d yyyy, h:mm:ss aa",
    MONTH: "MMM yyyy"
  },
  gb: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "dd/MM/yyyy",
    LL: "d MMM, yyyy",
    LLL: "d MMM yyyy, HH:mm",
    LLLL: "d MMM yyyy, HH:mm:ss",
    MONTH: "MMM yyyy"
  },
  il: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "dd/MM/yyyy",
    LL: "d MMM, yyyy",
    LLL: "d MMM yyyy, HH:mm",
    LLLL: "d MMM yyyy, HH:mm:ss",
    MONTH: "MMM yyyy"
  },
  us: {
    LT: "h:mm aa",
    LTS: "h:mm:ss aa",
    L: "MM/d/yyyy",
    LL: "MMM d, yyyy",
    LLL: "MMM d yyyy, h:mm aa",
    LLLL: "MMM d yyyy, h:mm:ss aa",
    MONTH: "MMM yyyy"
  }
};
function p(r = {}) {
  const t = I(j), {
    timeZone: e = "utc",
    template: n = t.template || "LLL",
    empty: a = t.empty || "—",
    locale: s = t.locale || "il"
  } = r;
  return (c, i = n) => {
    if (c == null)
      return a;
    if (Array.isArray(c))
      throw new Error("Debug: Used useDateFormat for range formatting. Please use useDateRangeFormat");
    const d = tt[s];
    let h;
    i in d ? h = d[i] : h = i;
    const g = u.isDate(c) ? c : new Date(c);
    if (!u.isValid(g))
      return a;
    const w = e === "utc" ? C(g, e) : e === "local" ? g : K(g, e);
    return w === void 0 ? a : u.format(w, h);
  };
}
const dn = (r = {}) => {
  const t = I(j), {
    timeZone: e = "utc",
    template: n = t.template || "LLL",
    empty: a = "",
    locale: s = t.locale || "il"
  } = r, c = p({ timeZone: e, template: n, locale: s, empty: "*" });
  return (i) => {
    if (i == null || i.filter((d) => d != null).length === 0)
      return a;
    if (!Array.isArray(i))
      throw new Error("value is not array");
    return i.map((d) => c(d));
  };
}, V = ({ children: r }) => /* @__PURE__ */ f("span", { style: { whiteSpace: "noWrap" }, children: r }), on = ({ value: r }) => r[0] === r[1] ? /* @__PURE__ */ f(D, { children: r[0] }) : /* @__PURE__ */ T(D, { children: [
  r[0],
  " - ",
  r[1]
] }), Sn = ({
  value: r = [],
  timeZone: t,
  template: e,
  dataRangePlaneText: n = !1
}) => {
  let a;
  try {
    a = dn({ timeZone: t, template: e })(r);
  } catch (s) {
    return console.error("DateRangeFormatter Error", s), s instanceof Error ? /* @__PURE__ */ f(D, { children: s.message }) : /* @__PURE__ */ f(D, { children: "An unknown error occurred" });
  }
  return Array.isArray(a) ? n ? /* @__PURE__ */ f(on, { value: a }) : /* @__PURE__ */ f(fn, { value: a }) : a;
}, fn = ({ value: r }) => r[0] === r[1] ? /* @__PURE__ */ f(V, { children: r[0] }) : /* @__PURE__ */ f("span", { style: { display: "inline-block" }, children: /* @__PURE__ */ T("span", { style: { display: "flex", flexWrap: "wrap" }, children: [
  /* @__PURE__ */ T(V, { children: [
    r[0],
    " - "
  ] }),
  r[1] && /* @__PURE__ */ f(V, { children: r[1] })
] }) }), _n = ({
  value: r,
  timeZone: t,
  template: e
}) => {
  try {
    const a = p({ timeZone: t, template: e })(r);
    return /* @__PURE__ */ f(D, { children: a });
  } catch (n) {
    return console.error("DateValueFormatter Error", n), n instanceof Error ? /* @__PURE__ */ f(D, { children: n.message }) : /* @__PURE__ */ f(D, { children: "An unknown error occurred" });
  }
}, Yn = ({
  timeZone: r = "utc",
  template: t = "MMMM yyyy",
  empty: e,
  locale: n
} = {}) => {
  const a = p({
    template: t,
    empty: e,
    locale: n,
    timeZone: r
  });
  return ({ month: s, year: c }) => {
    const i = `${s}`.padStart(2, "0");
    return a(`${c}-${i}-01T00:00:00.000Z`);
  };
}, Ln = (r) => {
  const t = I(j);
  return tt[r || t.locale];
}, Fn = ({
  children: r,
  presets: t,
  locale: e,
  template: n,
  empty: a
}) => /* @__PURE__ */ f(un, { presets: t, children: /* @__PURE__ */ f(cn, { locale: e, template: n, empty: a, children: r }) });
function P({
  maximumFractionDigits: r,
  minimumFractionDigits: t = 0,
  type: e,
  empty: n,
  currency: a,
  notation: s
}) {
  const c = B(() => new Intl.NumberFormat("en-US", {
    maximumFractionDigits: r,
    minimumFractionDigits: t,
    style: e,
    currency: a,
    notation: s
  }), [a, e, r, t]);
  return function(d) {
    return typeof d == "number" && Number.isFinite(d) ? c.format(d) : n;
  };
}
function ln({
  precision: r = 2,
  empty: t = "-",
  currency: e = "USD",
  notation: n
} = {}) {
  return P({
    type: "currency",
    maximumFractionDigits: r,
    empty: t,
    currency: e,
    notation: n
  });
}
const mn = ({ precision: r = 2, empty: t = "-", notation: e } = {}) => P({
  type: "decimal",
  maximumFractionDigits: r,
  empty: t,
  notation: e
}), hn = ({ precision: r = 2, empty: t = "-" } = {}) => {
  const e = P({
    type: "percent",
    maximumFractionDigits: r,
    empty: t
  });
  return (n) => typeof n == "number" && Number.isFinite(n) ? e(Number.isFinite(n) ? n / 100 : n) : t;
}, ee = ({
  formatter: r,
  empty: t = ""
}) => (e) => {
  if (e == null || e.filter((n) => n != null).length === 0)
    return t;
  if (!Array.isArray(e))
    throw new Error("value is not array");
  return e.map((n) => r(n));
}, yn = ({ precision: r = 2, empty: t = "*" } = {}) => {
  const e = P({
    type: "decimal",
    maximumFractionDigits: r,
    empty: t
  });
  return ee({
    formatter: e
  });
}, gn = (r) => typeof r == "number" && Number.isFinite(r) ? Number.isFinite(r) ? r / 100 : r : null, Mn = ({ precision: r = 2, empty: t = "" } = {}) => {
  const e = P({
    type: "percent",
    maximumFractionDigits: r,
    empty: t
  }), n = ee({
    formatter: e
  });
  return (a) => {
    if (a == null)
      return "";
    const s = a.map((c) => gn(c));
    return n(s);
  };
}, bn = ({
  precision: r = 2,
  empty: t = "*",
  currency: e = "USD"
} = {}) => {
  const n = P({
    type: "currency",
    maximumFractionDigits: r,
    empty: t,
    currency: e
  });
  return ee({
    formatter: n
  });
};
function kn() {
  return (r) => {
    var e;
    return (e = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: "currency",
      currency: r
    }).formatToParts(0).find((n) => n.type === "currency")) == null ? void 0 : e.value;
  };
}
const _ = ({ children: r }) => /* @__PURE__ */ f("span", { style: { whiteSpace: "noWrap" }, children: r }), X = ({
  formattedValue: r,
  empty: t = "*"
}) => Array.isArray(r) ? r[0] === r[1] ? /* @__PURE__ */ f(_, { children: r[0] }) : r[0] === t ? /* @__PURE__ */ T(D, { children: [
  /* @__PURE__ */ f(_, { children: "max " }),
  /* @__PURE__ */ f(_, { children: r[1] })
] }) : r[1] === t ? /* @__PURE__ */ T(D, { children: [
  /* @__PURE__ */ f(_, { children: "min " }),
  /* @__PURE__ */ f(_, { children: r[0] })
] }) : /* @__PURE__ */ f("span", { style: { display: "inline-block" }, children: /* @__PURE__ */ T("span", { style: { display: "flex", flexWrap: "wrap" }, children: [
  /* @__PURE__ */ f(_, { children: r[0] }),
  r[1] && /* @__PURE__ */ T(_, { children: [
    " - ",
    r[1]
  ] })
] }) }) : /* @__PURE__ */ f(D, { children: r }), rt = ({
  currency: r,
  precision: t,
  value: e,
  empty: n = "*"
}) => {
  const s = bn({ currency: r, precision: t, empty: n })(e);
  return /* @__PURE__ */ f(X, { formattedValue: s, empty: n });
};
rt.displayName = "NumberRangeFormatter.Currency";
const nt = ({ precision: r, empty: t = "*", value: e }) => {
  const a = Mn({ precision: r, empty: t })(e);
  return /* @__PURE__ */ f(X, { formattedValue: a, empty: t });
};
nt.displayName = "NumberRangeFormatter.Percent";
const at = ({ precision: r, empty: t = "*", value: e }) => {
  const a = yn({ precision: r, empty: t })(e);
  return /* @__PURE__ */ f(X, { formattedValue: a, empty: t });
};
at.displayName = "NumberRangeFormatter.Decimal";
const Pn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Currency: rt,
  Decimal: at,
  NumberRangeFormatter: X,
  Percent: nt
}, Symbol.toStringTag, { value: "Module" })), R = ({ currency: r, precision: t, value: e, notation: n }) => {
  const s = ln({ currency: r, precision: t, notation: n })(e);
  return /* @__PURE__ */ f(D, { children: s });
};
R.displayName = "NumberValueFormatter.Currency";
const st = ({
  precision: r,
  value: t
}) => {
  const n = hn({ precision: r })(t);
  return /* @__PURE__ */ f(D, { children: n });
};
st.displayName = "NumberValueFormatter.Percent";
const ut = ({
  precision: r,
  value: t,
  notation: e
}) => {
  const a = mn({ precision: r, notation: e })(t);
  return /* @__PURE__ */ f(D, { children: a });
};
ut.displayName = "NumberValueFormatter.Decimal";
const Nn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Currency: R,
  Decimal: ut,
  Percent: st
}, Symbol.toStringTag, { value: "Module" })), An = ({
  amount: r,
  currencyCode: t,
  amountBase: e,
  currencyCodeBase: n,
  vertical: a,
  ...s
}) => {
  const c = r !== void 0, d = e !== void 0 && t !== n;
  return /* @__PURE__ */ T("span", { children: [
    c ? /* @__PURE__ */ f(R, { value: r, currency: t }) : null,
    c && d ? a ? /* @__PURE__ */ f("br", {}) : /* @__PURE__ */ f("span", { children: " " }) : null,
    d ? /* @__PURE__ */ T("span", { ...s, children: [
      "(",
      /* @__PURE__ */ f(R, { value: e, currency: n }),
      ")"
    ] }) : null
  ] });
};
export {
  An as AmountFormatter,
  Fn as DateProvider,
  Sn as DateRangeFormatter,
  _n as DateValueFormatter,
  Pn as NumberRangeFormatter,
  Nn as NumberValueFormatter,
  l as createRangePreset,
  u as dateFNS,
  sn as defaultRangePreset,
  K as fromTimeZoneToUTC,
  C as fromUTCToTimeZone,
  tt as longDateFormats,
  On as rangePresets,
  Z as toDate,
  Ne as toISOString,
  ln as useCurrencyFormat,
  kn as useCurrencySymbol,
  p as useDateFormat,
  dn as useDateRangeFormat,
  Tn as useDateRangePresets,
  Ln as useDateTemplates,
  P as useFormat,
  Yn as useMonthFormat,
  mn as useNumberFormat,
  hn as usePercentFormat,
  bn as useRangeCurrencyFormat,
  yn as useRangeNumberFormat,
  Mn as useRangePercentFormat
};
